import { api } from 'API';
import { slashDateFormat } from 'Config';
import { format } from 'date-fns';
import { addImposterToUrl } from 'Utils';
const baseUrl = '/notifications';
export interface INotificationsDocument {
  itemId: number;
  notifciationTypeId: number;
  title: string;
  description: string;
  documentData: {
    documentBase64: string;
    documentNameWithExtension: string;
    documentName: string;
  };
  isVisited: boolean;
  date: Date;
}

export interface IMessage {
  itemId: number;
  notifciationTypeId: number;
  title: string;
  description: string;
  linkText: string;
  isVisited: boolean;
  date: Date;
  linkUrl: string;
}

export interface IReferralsOrBenefits {
  notifciationTypeId: number;
  title: string;
  description: string;
  linkText: string;
  isVisited: boolean;
  amount: number;
  linkUrl: string;
}

export interface INotificationsMessages {
  benefits?: IReferralsOrBenefits;
  other: IMessage[];
  referrals?: IReferralsOrBenefits;
}

export interface INotifications {
  documents: INotificationsDocument[];
  messages: INotificationsMessages;
}

export interface IUnreadNotifications {
  documentsCount: number;
  messagesCount: number;
}

export interface IVisitNotificationBody {
  itemId: number;
  typeId: number;
}

export const getNotifications = async () => {
  let lastMonth = new Date();
  lastMonth.setMonth(lastMonth.getMonth() - 1);
  const formattedLastMonth = format(lastMonth, slashDateFormat);
  const notificationsData = await api.get<INotifications>(
    addImposterToUrl(baseUrl + '?FromDate=' + formattedLastMonth, false)
  );
  if (notificationsData.data) {
    return notificationsData.data;
  }
};

export const markNotificationAsVisited = async (
  body: IVisitNotificationBody
) => {
  await api.post(addImposterToUrl(`${baseUrl}/visited`, true), body);
};

export const markReferralsOrBenefitsAsVisited = async (
  fileNumber: string,
  notifciationTypeId: number
) => {
  await api.get(
    `${process.env.REACT_APP_VISITED_API}?fileNumber=${fileNumber}&type=${notifciationTypeId}`
  );
};

/**
 * TODO: UnreadNotificatons function at -
 * feature/7959 or commit 431fc24f ( 431fc24f1108177e4deb0a1807cbdb45016260bb )
 **/
